<template>
<div>
    <button class="btn btn-secondary btn-upload mb-2" style="margin-top:-0.5rem;" @click="openUploadModal"><i class="fas fa-fw fa-upload"></i> Upload files</button>
    <img :src="url" />
    <!--div class="btn btn-secondary btn-upload mb-2" style="margin-top:-0.5rem;"><i class="fas fa-fw fa-upload"></i> Upload File <input type="file" id="fileupload" accept="image/jpeg" @change="detectFiles($event.target.files)"></div>-->
    <!--<div class="progress-bar" v-bind:class="{ showprogress: uploading }" :style="{ width: progressUpload + '%'}">{{ progressUpload }}%</div>-->
    <!-- <div v-if="success" class="alert alert-success">{{success}}</div>-->
</div>
</template>

<script>
import {
    Firebase,
    db
} from '../main'

import {
    mapGetters
} from "vuex";

export default {
    props: {
        job: Object,
    },
    data() {
        return {
            progressUpload: 0,
            file: null,
            uploadTask: '',
            uploading: false,
            url: null,
            success: null,
            //urla: '',
            //publicId: ''
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
    },
    methods: {
        openUploadModal() {
            const t = this;
            console.log('sdf');
            window.cloudinary.openUploadWidget({
                    cloud_name: 'itrecycla',
                    upload_preset: 'ml_default',
                    folder: t.job.jobid,
                    sources: [ 'local', 'url', 'camera'],
                    preBatch:function(cb, data){
                        console.log(data.files[0]);
                        cb(); 
                        t.file = data.files[0];
                        /*if (data.files[0].name === "TopSecret") {
                            cb({cancel: true}); 
                        }else { 
                            cb(); 
                        }*/
                    }
                 },
                (error, result) => {
                    if (!error && result && result.event === "success") {
                        console.log('Done uploading..: ', result.info);
                        //t.urla = result.info.url;
                        //t.publicId = result.info.public_id;
                        t.saveFileData(result.info)
                    }
                }).open();
        },
        getFileName(filePath) {
            console.log(filePath);
            return filePath.substr(filePath.lastIndexOf('\\') + 1).split('.')[0];
        },
        detectFiles(fileList) {
            Array.from(Array(fileList.length).keys()).map(x => {
                this.upload(fileList[x])
            })
        },
        upload(file) {
            const t = this;
            t.file = file;
            console.log('storage', Firebase);
            var storageRef = Firebase.storage().ref();
            var imgRef = storageRef.child('jobs/' + t.job.jobid + '/' + file.name);
            console.log('t.file', t.file)
            this.uploadTask = imgRef.put(file);
        },
        saveFileData(fdata){
                        const t = this;
                        const job = {
                            ...t.job
                        };
                        if (!t.job.adminAttachments) {
                            job.adminAttachments = [];
                        }
                        var newfile = {};
                        if(t.file){
                            newfile.name = t.file.name;
                        }else if(fdata.original_extension){
                            newfile.name = fdata.original_filename + '.' + fdata.original_extension;
                        }else{
                            newfile.name = fdata.original_filename;
                        }
                       // if (t.file.lastModified) newfile.lastModified = fdata.lastModified;
                        if (fdata.resource_type) newfile.type = fdata.resource_type;
                        if (fdata.bytes) newfile.size = fdata.bytes;
                        newfile.path = fdata.secure_url;
                        if (fdata.thumbnail_url) newfile.thumbnail = fdata.thumbnail_url;
                        if (fdata.format) newfile.format = fdata.format;

                        newfile.enteredBy = t.user.data.name;
                        newfile.enteredUID = t.user.auth.uid;
                        newfile.submitted = new Date().toISOString();

                        job.adminAttachments.push(newfile);
                        console.log('t.filer', newfile)

                        if (t.job['.key']) { //Job Exisits
                            db.ref('jobs2020/' + t.job['.key'])
                                .set(job)
                                .then(() => {
                                    console.log('job updated!')
                                    t.file = null;
                                    t.progressUpload = 0;
                                    t.uploading = false;
                                    t.uploadTask = '';
                                    //document.getElementById("fileupload").value = "";
                                    t.success = "Attachment Uploaded";
                                })
                        }
        }
    },
    watch: {
        uploadTask: function () {
            const t = this;
            this.uploading = true;
            this.uploadTask.on('state_changed', sp => {
                    this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100);
                },
                null,
                () => {
                    this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                        this.url = downloadURL;

                        const job = {
                            ...t.job
                        };
                        if (!t.job.adminAttachments) {
                            job.adminAttachments = [];
                        }
                        var newfile = {};
                        if (t.file.name) newfile.name = t.file.name;
                        if (t.file.lastModified) newfile.lastModified = t.file.lastModified;
                        if (t.file.type) newfile.type = t.file.type;
                        if (t.file.size) newfile.size = t.file.size;
                        newfile.path = downloadURL;
                        newfile.enteredBy = t.user.data.name;
                        newfile.enteredUID = t.user.auth.uid;
                        newfile.submitted = new Date().toISOString();

                        job.adminAttachments.push(newfile);
                        console.log('t.filer', newfile)

                        if (t.job['.key']) { //Job Exisits
                            db.ref('jobs2020/' + t.job['.key'])
                                .set(job)
                                .then(() => {
                                    console.log('job updated!')
                                    t.file = null;
                                    t.progressUpload = 0;
                                    t.uploading = false;
                                    t.uploadTask = '';
                                    document.getElementById("fileupload").value = "";
                                    t.success = "Attachment Uploaded";
                                })
                        }

                    })
                })
        }
    }
}
</script>

<style>
.btn-upload {
    position: relative;
}

.btn-upload input[type=file] {
    opacity: 0;
    position: absolute;
    left: 0;

}

.progress-bar {
    display: none;
    font-size: 12px;
    line-height: 1;
}

.progress-bar.showprogress {
    margin: -6px 0 2px;
    display: block;
}
</style>
